export default __webpack_public_path__ + "static/media/recruiting-daily-logo.a704e145.png";